import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Feature {
  id: string;
  title: string;
  description: string;
  icon: 'ShieldCheckIcon' | 'MapIcon' | 'PhoneIcon' | 'DocumentCheckIcon';
}

const features: Feature[] = [
{
  id: 'safety_verification',
  title: 'Regular Maintenance',
  description: 'All scooters undergo daily safety checks and regular maintenance to ensure optimal performance.',
  icon: 'ShieldCheckIcon'
},
{
  id: 'safety_tracking',
  title: 'GPS Tracking',
  description: 'Every scooter is GPS-enabled for your safety and to help you find nearby available scooters.',
  icon: 'MapIcon'
},
{
  id: 'safety_sos',
  title: 'In-App Support',
  description: 'Instant access to customer support and emergency assistance directly from the app.',
  icon: 'PhoneIcon'
},
{
  id: 'safety_insurance',
  title: 'Ride Insurance',
  description: 'Every ride is covered by comprehensive insurance for your peace of mind.',
  icon: 'DocumentCheckIcon'
}];


export default function SafetyFeatures() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <span className="inline-block px-4 py-2 rounded-full bg-success/10 text-success text-sm font-body font-semibold mb-4">
            Your Safety First
          </span>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary mb-4">
            Safety Features
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            We're committed to making every scooter ride safe and secure with industry-leading safety standards.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Features List */}
          <div className="space-y-6 reveal">
            {features.map((feature, index) =>
            <div
              key={feature.id}
              className={`flex items-start gap-4 p-6 rounded-2xl bg-muted/50 hover:bg-muted transition-all reveal-delay-${index * 100}`}>
              
                <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-success/10 flex items-center justify-center">
                  <Icon
                  name={feature.icon}
                  variant="solid"
                  size={28}
                  className="text-success" />
                
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-display font-bold text-primary mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground font-body">
                    {feature.description}
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Phone Mockup */}
          <div className="relative reveal reveal-delay-200">
            <div className="relative z-10 mx-auto w-[300px] h-[600px] bg-white rounded-[3rem] shadow-2xl border-8 border-gray-800 overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-gray-800 rounded-b-3xl z-20" />
              <div className="w-full h-full bg-gradient-to-br from-blue-50 to-indigo-50 p-4">
                <AppImage
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_10c37f8f3-1764846461425.png"
                  alt="ScootRide app safety features screen showing GPS tracking map with scooter locations, emergency support button, and ride insurance details"
                  className="w-full h-full object-cover rounded-2xl" />
                
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-success/20 rounded-full blur-3xl" />
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-secondary/20 rounded-full blur-3xl" />
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16 reveal reveal-delay-300">
          <a
            href="/homepage#safety-details"
            className="inline-flex items-center gap-2 text-success hover:text-success/80 transition-colors font-body font-semibold">
            
            Learn More About Scooter Safety
            <Icon name="ArrowRightIcon" size={20} />
          </a>
        </div>
      </div>
    </section>);

}